import React from 'react';
import { Company } from '../../../../../types/company';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { t } from '../../../../../types/translation/Translator';
import { FeatureToggleItem, FeatureToggleTitle, FeatureToggleExplanation, FeatureToggleInformation } from '../common';

interface CompanyFeatureTogglesViewProps {
  company: Company;
  update: (company: Company) => Promise<void>;
}

export default function CompanyFeatureTogglesView({ company, update }: CompanyFeatureTogglesViewProps) {
  const copy = new Company(company);
  const toggles = copy.settings.featureToggles.company;

  return (
    <FeatureToggleItem
      solo
      value={toggles.sessionStorage}
      onChange={async value => await update(copy.withCompanySessionStorageFeatureToggle(value))}
    >
      <FeatureToggleTitle text={t(TranslationKey.sessionStorageSessionStorageFeatureToggleTitle).singular.upper} />
      <FeatureToggleExplanation
        text={t(TranslationKey.sessionStorageSessionStorageFeatureToggleExplanation).singular.upper}
      />
      <FeatureToggleInformation
        text={t(TranslationKey.sessionStorageSessionStorageFeatureToggleInformation).singular.upper}
      />
    </FeatureToggleItem>
  );
}
